import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BookmarkIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getGuide } from '../../api/guides/get-guide'
import { updateGuide } from '../../api/guides/update-guide'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import GuideForm from '../../components/pages/guides/guide-form'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { mapGuideDataDefaultValues } from './utils'

const GuideUpdatePage = () => {
  const { navigate } = useNavigator()
  const queryClient = useQueryClient()
  const { id } = useParams<{ id: string }>()

  const { data: guide, isLoading } = useQuery({
    queryKey: ['guide', id],
    queryFn: () => getGuide(+id!),
    enabled: !!id && !isNaN(+id)
  })

  const updateMutation = useMutation({
    mutationFn: updateGuide,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['guide', id] })
      toast.success(`Guide "${data.name}" modifié avec succès`)
    }
  })

  if (isLoading) return <LoadingScreen />
  if (!guide || !id || isNaN(parseInt(id))) return <div>Guide non trouvé</div>

  return (
    <div>
      <UserNavBar title={'Modifier le guide'} icon={BookmarkIcon} />

      <div className={'h-4'} />

      <Box className="px-6 py-8">
        <GuideForm
          defaultValues={mapGuideDataDefaultValues(guide)}
          buttonsConfig={updateButtonsConfig({
            onUpdate: (data) => updateMutation.mutateAsync({ id: +id, ...data }),
            onUpdateThenCreate: async (data) => {
              await updateMutation.mutateAsync({ id: +id, ...data })
              navigate(Paths.GUIDE_CREATE_PAGE)
            },
            onUpdateThenList: async (data) => {
              await updateMutation.mutateAsync({ id: +id, ...data })
              navigate(Paths.GUIDE_LIST_PAGE, { replace: true })
            },
            onCancel: () => navigate(Paths.GUIDE_LIST_PAGE, { replace: true })
          })}
        />
      </Box>
    </div>
  )
}

export default GuideUpdatePage
